"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
type NavLinkProps = {
  href: string;
  label: string;
  icon?: LucideIcon;
};
export function NavLink(t0) {
  const $ = _c(18);
  const {
    href,
    label,
    icon: Icon
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== href || $[1] !== pathname) {
    t1 = pathname === href || href !== "/" && pathname.startsWith(`${href}/`);
    $[0] = href;
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isActive = t1;
  const t2 = isActive ? "bg-primary/10 text-primary shadow-[inset_0_0_0_1px_rgba(var(--primary),0.1)]" : "text-muted-foreground hover:bg-muted hover:text-foreground";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold transition-all duration-200", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isActive) {
    t4 = isActive && <div className="absolute left-0 top-1/2 h-5 w-1 -translate-y-1/2 rounded-full bg-primary" />;
    $[5] = isActive;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== Icon || $[8] !== isActive) {
    t5 = Icon && <Icon className={cn("h-4 w-4 transition-transform group-hover:scale-110", isActive ? "text-primary" : "text-muted-foreground/70")} />;
    $[7] = Icon;
    $[8] = isActive;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== label) {
    t6 = <span className="tracking-tight">{label}</span>;
    $[10] = label;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== href || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <Link href={href} className={t3}>{t4}{t5}{t6}</Link>;
    $[12] = href;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}